import LocalizedLink from "@/components/LocalizedLink.vue";

export default {
    name: 'Breadcrumb',
    props: {
    },
    components: { LocalizedLink },
    methods: { }

}
